export const AI_CHAT_FEEDBACK_ORIGIN = 'ACCOUNT_SETTINGS'

export const CHAT_HISTORY_MESSAGE_TYPES = {
  BOT: 'BOT',
  USER: 'USER',
} as const
